
import { Navigate } from "react-router-dom";
import { useAuth } from "../AuthContext";

export default function Home() {
  let auth = useAuth();
  if (auth.user) {
    return <Navigate to="/account" replace />;
  }
  return <Navigate to="/login" replace />;
}